export default "__VITE_ASSET__DHBY0QNM__"